import { z } from 'zod';
import { OptomechElementSchema } from './optomechAssembly.js';

/**
 * The current design's elements as the Optomech tab lists them (GET
 * /optomech/elements), judged by the backend's own rule so the browser keeps
 * no copy of it (src/services/optomech/elements.ts listElements). Every
 * element is listed, numbered L1, L2, … as a composition numbers it; each of
 * the two rules that take an element answers with its result or its refusal.
 */
export const OptomechDesignElementSchema = z.object({
  element_id: z.string().min(1),
  /** The element's surfaces front to rear, read from the media alone. */
  surfaces: z.array(z.number().int()).min(2),
  /** The element as a composition takes it (optomechCompose), or null when `refused` says why not. */
  element: OptomechElementSchema.nullable(),
  refused: z.string().nullable(),
  /**
   * The parametric singlet a run meshes from this element (one body, two curved faces), or null when `singlet_refused` says why not.
   * `glass` is its catalog glass, read whether or not the element composes; null when the design names none (a model, offset or ideal glass).
   */
  singlet: z.object({ semi_diameter_mm: z.number().positive(), glass: z.string().nullable() }).strict().nullable(),
  singlet_refused: z.string().nullable(),
}).strict();
export type OptomechDesignElement = z.infer<typeof OptomechDesignElementSchema>;

/** Empty for a conversation with no system yet. */
export const OptomechDesignElementListSchema = z.object({
  elements: z.array(OptomechDesignElementSchema),
}).strict();
export type OptomechDesignElementList = z.infer<typeof OptomechDesignElementListSchema>;
